import { List, Datagrid, TextField } from "react-admin";

import LayoutContainer from "../components/LayoutContainer";
import useDataGridStyles from "../components/DataGridStyle";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import PermissionChecker from "../../../components/PermissionChecker";
import exporter from "../../../utils/exporter";
import CustomAction from "../components/CustomAction";
import CustomDateField from "../components/CustomDateField";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     position: "absolute",
//     top: 0,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     overflow: "auto",
//   },
// }));

const SubcategoryList = (props) => {
  const title = "Subcategory";
  const headers = [
    { label: "Name", source: "name" },
    { label: "Description", source: "desc" },
    { label: "Category", source: "category.name" },
    { label: "Status", source: "status" },
    { label: "Created", source: "time" },
  ];
  const classes = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Sub-categories" />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, headers, title)}
        classes={{ content: classes.content }}
        actions={<CustomAction labelCreate="Add Subcategory" />}
      >
        <Datagrid
          rowClick="show"
          classes={{ headerCell: classes.header, rowCell: classes.row }}
        >
          <TextField label="Name" source="name" />
          <TextField label="Description" source="desc" />
          <TextField label="Category" source="category.name" />
          <TextField label="Status" source="status" />
          <CustomDateField label="Created" source="time" />
        </Datagrid>
      </List>
      <PermissionChecker code="Page.Merchant.Management.Category" />
    </LayoutContainer>
  );
};
/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default SubcategoryList;
